<h1 mat-dialog-title>Edit User</h1>

<mat-dialog-content>

    <form fxLayoutGap="1rem" fxLayout="column" [formGroup]="formGroup">
        <mat-form-field>
            <mat-label>Ready Player Me Avatar URL</mat-label>
            <textarea matInput formControlName="rpmAvatarURL"></textarea>
            <mat-error *ngIf="formGroup.controls['rpmAvatarURL'].hasError('pattern')">Invalid</mat-error>
        </mat-form-field>
    </form>

</mat-dialog-content>

<mat-dialog-actions>
    <div fxLayoutGap="1rem" fxLayout="row" fxLayoutAlign="end" fxFlexFill>
        <button mat-button (click)="cancel()">Cancel</button>
        <button mat-button (click)="submit()">OK</button>
    </div>
</mat-dialog-actions>